import React, { useReducer, useEffect, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { connect } from 'react-redux';
import { getMenuByRole } from './Menu';

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
}

const SideBar = ({ user }) => {
  const [state, setState] = useReducer(reducer, initialState);

  const [hideOnScroll, setHideOnScroll] = useState(true)
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y
      if (isShow !== hideOnScroll) setHideOnScroll(isShow)
    },
    [hideOnScroll]
  )

  const handleMenuActive = status => {
    if (state.active === status) {
      setState({ active: "" });
    } else {
      setState({ active: status });
    }
  }

  /// Path
  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  // Get menu items based on user role
  const userRole = user?.role || 'user';
  const MenuList = getMenuByRole(userRole);

  useEffect(() => {
    const currentPath = window.location.pathname;
    MenuList.forEach((data) => {
      if (currentPath === data.to || currentPath.includes(data.to)) {
        setState({ active: data.title });
      }
      if (data.content) {
        data.content.forEach(subItem => {
          if (currentPath === subItem.to || currentPath.includes(subItem.to)) {
            setState({ active: data.title });
          }
        });
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div className="deznav">
      <PerfectScrollbar className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            const hasSubmenu = data.content && data.content.length > 0;
            
            return (
              <li className={`${state.active === data.title ? 'mm-active' : ''} ${hasSubmenu ? 'has-arrow' : ''}`}
                key={index}
              >
                {hasSubmenu ? (
                  <>
                    <Link to="#"
                      onClick={() => { handleMenuActive(data.title) }}
                    >
                      {data.iconStyle}
                      <span className="nav-text">{data.title}</span>
                    </Link>
                    <ul className={`${state.active === data.title ? 'mm-collapse mm-show' : 'mm-collapse'}`}>
                      {data.content.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link to={subItem.to}>
                            <span className="nav-text">{subItem.title}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <Link to={data.to}
                    onClick={() => { handleMenuActive(data.title) }}
                  >
                    {data.iconStyle}
                    <span className="nav-text">{data.title}</span>
                  </Link>
                )}
              </li>
            )
          })}
        </ul>
      </PerfectScrollbar>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps)(SideBar);
